<template>
  <div></div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  mounted() {
    Bus.$on('deleteLeadButtonToggled', (lead, isAdmin) => {
      this.hasDeal = false;
      this.lead = lead;

      this.$http.get(`/lead/${this.lead.hashid}/deals`).then(({ data }) => {
        const { deals } = data;
        if (deals > 0) {
          this.hasDeal = true;
        }

        if (isAdmin && this.hasDeal) {
          this.showDeleteAlertHasDealAndIsAdmin();
        }
        if (!isAdmin && this.hasDeal) {
          this.showDeleteAlertHasDealAndIsNotAdmin();
        }
        if (!this.hasDeal) {
          this.showDeleteAlertHasNoDeal();
        }
      }).catch((error) => {
        Alert.error('Falha ao deletar lead!')
      });
    });
  },

  data() {
    return {
      lead: ''
    };
  },

  methods: {
    showDeleteAlertHasNoDeal () {
      Swal.fire({
          iconHtml: '<img src="/build/icons/question-circle.svg" style="width: 72px; height: 72px;">',
          title: this.__('Deseja excluir este lead?'),
          html: `<div class="container-basic mb-3">`
                +   `<span class="container-basic-title">${this.__('Nenhum negócio vinculado a este lead.')}</span>`
                + `</div>`,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.__('Continuar'),
          cancelButtonColor: 'transparent',
          cancelButtonText: this.__('Cancelar'),
          showCancelButton: true,
          customClass: {
            container:'container-delete-lead',
            confirmButton: 'salesflow-btn salesflow-btn-secondary',
            cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
            icon: 'no-border'
          }
      }).then((result) => {
        if (result.dismiss !== 'cancel') {
          this.deleteLead();
        }
      });
    },

    showDeleteAlertHasDealAndIsAdmin () {
      Swal.fire({
          iconHtml: '<img src="/build/icons/delete-alert.svg" style="width: 69.186px; height: 68.208px;">',
          title: this.__('Este lead possui negócios vinculados, deseja mesmo assim excluir?'),
          html: `<div class="info-container">`
                +   `<span class="info-title">${this.__('Ao excluir, todos os negócios serão deletados do sistema, incluindo dados do dashboard, relatórios e progresso.')}</span>`
                + `</div>`,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.__('Continuar'),
          cancelButtonColor: 'transparent',
          cancelButtonText: this.__('Cancelar'),
          showCancelButton: true,
          customClass: {
            container:'container-delete-lead',
            confirmButton: 'salesflow-btn salesflow-btn-secondary',
            cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
            icon: 'no-border'
          }
      }).then((result) => {
        if (result.dismiss !== 'cancel') {
          this.deleteLead();
        }
      });
      document.getElementById('swal2-html-container').style.marginTop = '8px';
    },

    showDeleteAlertHasDealAndIsNotAdmin () {
      Swal.fire({
          iconHtml: '<img src="/build/icons/delete-alert.svg" style="width: 69.186px; height: 68.208px;">',
          title: this.__('Você não possui permissão para excluir este lead!'),
          html: `<div class="info-container">`
                +   `<span class="info-title">${this.__('Este lead possui negócios vinculados portanto somente um usuário administrador poderá exclui-lo.')}</span>`
                + `</div>`,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.__('Fechar'),
          customClass: {
            container:'container-delete-lead',
            confirmButton: 'salesflow-btn salesflow-btn-secondary',
            icon: 'no-border'
          }
      });
      document.querySelector('.swal2-popup').style.paddingBottom = '56px';
    },

    deleteLead () {
      this.$http.delete(`/lead/${this.lead.hashid}`)
        .then(() => {
          window.location = '/lead/all';
        }).catch((response) => {
          if (response.status === 403) {
            const message = response.data?.message ? response.data.message
            : 'Este lead possui negócios vinculados portanto somente um usuário administrador poderá exclui-lo.';
            Alert.error(this.__(message));
          } else {
            Alert.error(this.__('Erro ao excluir lead'));
          }
        });
    },
  },
};
</script>
<style lang="scss">
  @import '../../../sass/variables';
  @import '../../../sass/mixins';


  .container-delete-lead {
    .swal2-modal {
      width: 332px;
      border-radius: 16px;
      padding-bottom: 30px;
      background-color: $salesflow-bg-content;

      .swal2-icon {
        margin-top: 56px;
        margin-bottom: 24px;
      }

      h2 {
        @include salesflow-subtitle($font-weight: 700);
        margin-bottom: 0px;
        padding:0px;
        margin-right: 48px;
        margin-left: 48px;
      }

      .info-container{
        width: 236px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 8px;
        margin: auto;
        border: 1px solid #E14E4E;
        border-radius: 8px;
        background-color: #FFE3E3;

        .info-title {
          @include salesflow-text($color: #242424);
          @include salesflow-text($font-weight: 500);
        }

        .info-value {
          @include salesflow-text($font-weight: 600);
        }
      }
      .container-basic {
        width: 224px;
        height: 36px;
        display: flex;
        padding: 1rem 0.5rem;
        margin: auto;
        padding-top: 0px;
        padding-bottom: 0px;
        margin-bottom: 0px !important;
        .container-basic-title {
          @include salesflow-text($color: $salesflow-font-gray);
          font-weight: 500;
          font-size: 12px;
        }
      }
    }

    .swal2-html-container {
      margin-top: 24px;
    }

    .swal2-btn-cancel-transparent {
      @include salesflow-text($font-weight: 600, $color: $salesflow-font-gray);
      padding-top: 1rem;
      padding-bottom: 1.625rem;
      border: 0;
      text-decoration: underline;

      &:hover {
        color: $salesflow-primary-hover;
      }
    }

    .swal2-btn-full-line {
      flex-basis: 100%;
    }

    .swal2-actions {
      margin-top: 48px;
    }
  }

  .no-border {
    border: none !important;
    background: transparent !important;
  }
</style>
